import { store } from '@betacrew/jars-flux';
import { all, call, put, takeLatest, takeLeading } from 'redux-saga/effects';
import { componentKey, setAddNewCard, setLoadingState, setSelectedCard, setStripeSavedCardsList } from './ManageCardsSlice';
import { COMMON_LOADING_STATES } from '../../constants/constants';
import PaymentDataService from '../../../../services/PaymentDataService';
import { addNotifications } from '../../toaster/ToasterPortalSlice';
import General from '../../../../libs/utility/General';
import { MANAGE_CARDS_LOADING_STATES } from './constants';

export const { getStripeSavedCards, saveCardDetails, setDefaultCard } = {
    getStripeSavedCards: (payload) => {
        return {
            type: "MANAGE_CARD/GET_STRIPE_SAVED_CARDS",
            payload: payload
        }
    },
    
    saveCardDetails: (payload) => {
        return {
            type: "MANAGE_CARD/SAVE_CARD",
            payload
        }
    },
    
    setDefaultCard: (payload) => {
        return {
            type: "MANAGE_CARD/SET_DEFAULT_CARD",
            payload
        }
    },
}

function* getStripeSavedCardsAsync(action) {
    try {
        yield put(setLoadingState({ state: MANAGE_CARDS_LOADING_STATES.SAVED_CARDS_LOADING }));
        const response = yield PaymentDataService.GetSavedCardsList();
        if (response?.data) {
            const { Status, Message, Data } = response?.data;
            if (Status === 1) {
                if (Data) {
                    const selectedCard = Data.find(card => card.Selected);
                    const organizedCards = General.reorderArrayByActiveElementObj(Data, "Selected")

                    yield put(setStripeSavedCardsList(organizedCards));
                    yield put(setSelectedCard(selectedCard));
                } else {
                    yield put(setStripeSavedCardsList([]));
                }
            } else {
                yield put(addNotifications({ heading: "Failed to fetch the list of cards", message: Message }));
            }
        }
    } catch (error) {
        yield put(addNotifications({ heading: "Failed to fetch the list of cards", message: error?.response?.data?.Message }));
    } finally {
        yield put(setLoadingState({ state: MANAGE_CARDS_LOADING_STATES.SAVED_CARDS_READY }))
    }
}

function* setDefaultCardAsync(action) {
    try {
        yield put(setLoadingState({ state: MANAGE_CARDS_LOADING_STATES.SAVED_CARDS_LOADING }));
        const response = yield PaymentDataService.setDefaultCard(action.payload);
        if (response?.data) {
            const { Status, Message, Data } = response?.data;
            if (Status === 1) {
                if (Data) {
                    yield call(getStripeSavedCardsAsync);
                } else {
                    yield put(setStripeSavedCardsList([]));
                }
            } else {
                yield put(addNotifications({ heading: "Failed to fetch the list of cards", message: Message }));
            }
        }
    } catch (error) {
        yield put(addNotifications({ heading: "Failed to fetch the list of cards", message: error?.response?.data?.Message }));
    } finally {
        yield put(setLoadingState({ state: MANAGE_CARDS_LOADING_STATES.SAVED_CARDS_READY }))
    }
}


function* saveCardDetailsAsync(action) {
    try {
        yield put(setLoadingState({ state: MANAGE_CARDS_LOADING_STATES.ADD_CARD_LOADING }));

        const response = yield PaymentDataService.addCardDetails(action.payload);
        const { Status, Message, Data } = response?.data;

        if (Status) {
            yield put(setAddNewCard(false))
            yield call(getStripeSavedCardsAsync)
        } else {
            yield put(addNotifications({ heading: "Failed to add the card", message: Message }));
        }

    } catch (error) {
        console.log(error)
        yield put(addNotifications({ heading: "Failed to add the card", message: error?.response?.data?.Message }));
    } finally {
        yield put(setLoadingState({ state: MANAGE_CARDS_LOADING_STATES.ADD_CARD_READY }))
    }
}
function* rootSaga() {
    yield all([
        takeLatest(getStripeSavedCards().type, getStripeSavedCardsAsync),
        takeLeading(saveCardDetails().type, saveCardDetailsAsync),
        takeLeading(setDefaultCard().type, setDefaultCardAsync),
    ]);
}
store.sagaManager.addSaga(componentKey, rootSaga);